export type NullOrUndefined<T> = T | undefined | null

export function ifDefined<T, R>(maybeValue: NullOrUndefined<T>, usage: (value: T) => R): R | undefined
export function ifDefined<T, R>(maybeValue: NullOrUndefined<T>, usage: (value: T) => R, defaultValue: R): R
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function ifDefined<T, R>(maybeValue: NullOrUndefined<T>, usage: (value: T) => R, defaultValue?: R) {
  if (maybeValue === undefined || maybeValue === null) return defaultValue
  return usage(maybeValue)
}
